export const CTA_LINK_BUTTON_PREFIX = "CTALinkButton";

export const CTA_LINK_BUTTON_CLASSES = {
  linkText: `${CTA_LINK_BUTTON_PREFIX}-linkText`,
};
